import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { EmploymentAccess } from '../employment-access.model';
import { EmploymentAccessDataFetcherService } from '../services/employment-access-data-fetcher.service';

@Injectable({ providedIn: 'root' })
export class ManagedEmploymentsAccessResolver implements Resolve<EmploymentAccess[]> {
  constructor(private employmentAccessDataFetcherService: EmploymentAccessDataFetcherService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<EmploymentAccess[]> {
    const reloadManagedEmploymentsAccess = route.data?.reloadManagedEmploymentsAccess;

    return this.employmentAccessDataFetcherService.fetchManagedEmploymentsAccessData(true, !!reloadManagedEmploymentsAccess);
  }
}
